import { ThemeColors } from '~/themes/colors'

interface MenuColors {
  Background: ThemeColors
  Border: ThemeColors
  BoxShadow: ThemeColors
  Separator: ThemeColors
}

export const MenuColors: MenuColors = {
  Background: {
    default: 'white',
  },
  Border: {
    default: 'gray.500',
  },
  Separator: {
    default: 'gray.400',
  },
  BoxShadow: {
    default: 'mask.gray.1300.20',
  },
}
